import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { getQuiz, deleteQuiz } from "../../../../redux/educator/actions";
import {
  selectQuizzes,
  selectQuizzesLoaded,
  selectQuizzesLoading,
} from "../../../../redux/educator/selector";
import { StateType } from "../../../../utils";

const mapStateToProps = (state: StateType) => ({
  quizzes: selectQuizzes(state),
  loading: selectQuizzesLoading(state),
  loaded: selectQuizzesLoaded(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getQuiz,
      deleteQuiz,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
